var __TEMP__ = require('./_baseIsNative.js');var baseIsNative = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getValue.js');var getValue = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = getNative;
